module.exports = __webpack_public_path__ + "static/media/sit_vehiculo.ebf786a6.svg";